import { render, staticRenderFns } from "./PrimaryDetailsIcon.vue?vue&type=template&id=6c6467e6&"
import script from "./PrimaryDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./PrimaryDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports